import { FeatureServiceProviderDefinition } from '@feature-hub/core';
import { defineFeatureappService, FeatureappService } from '@volkswagen-onehub/featureapp-service';

export const featureAppConfigs = {
  'Dealer Details': {
    baseUrl: 'https://v3-28-0.ds.dcc.feature-app.io',
    src: '/static/feature-app/detail/dealer-search-detail-umd.js',
    config: {
      formsAppId: 'Forms',
      dealerSearchPageId: 'dealer-search-page-id',
      dealerReviewsFeatureAppId: 'Dealer Review FA',
    },
    css: [],
    name: 'Dealer Details',
    trackingId: 'DCC-Search-DealerDetails-D6',
    version: '3.28.0',
    apiKey: process.env.DEALER_DETAILS_API_KEY,
  },
};

export function createFeatureAppService(): FeatureServiceProviderDefinition<FeatureappService> {
  return defineFeatureappService(featureAppConfigs);
}
